import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledTelephoneIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.6712 8.48438C11.8591 8.57812 12 8.78906 12 9.02344C12 9.04688 12 9.09375 12 9.14062L11.4364 11.5781C11.3659 11.8359 11.1546 12 10.8963 12C4.86106 12 0 7.14844 0 1.125C0 0.867188 0.164384 0.65625 0.422701 0.585938L2.86497 0.0234375C2.91194 0.0234375 2.9589 0 2.98239 0C3.21722 0 3.42857 0.140625 3.5225 0.351562L4.64971 2.97656C4.67319 3.04688 4.69667 3.11719 4.69667 3.1875C4.69667 3.375 4.60274 3.53906 4.48532 3.63281L3.05284 4.80469C3.92172 6.63281 5.37769 8.08594 7.20939 8.95312L8.38356 7.52344C8.4775 7.40625 8.64188 7.3125 8.80626 7.3125C8.9002 7.3125 8.97065 7.33594 9.0411 7.35938L11.6712 8.48438Z",
		fill: "#007AAF"
	})]
});
const ForwardRef = forwardRef(SvgFilledTelephoneIcon);
const Memo = memo(ForwardRef);
export default Memo;
